import { render, staticRenderFns } from "./RequestPayment.vue?vue&type=template&id=a5a4fcec&scoped=true"
import script from "./RequestPayment.vue?vue&type=script&lang=js"
export * from "./RequestPayment.vue?vue&type=script&lang=js"
import style0 from "./RequestPayment.vue?vue&type=style&index=0&id=a5a4fcec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5a4fcec",
  null
  
)

export default component.exports